import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-castro',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Castro icon</title><path d="M12 0C5.372 0 0 5.373 0 12s5.372 12 12 12c6.627 0 12-5.373 12-12S18.627 0 12 0zm-.002 13.991a2.052 2.052 0 1 1 0-4.105 2.052 2.052 0 0 1 0 4.105zm4.995 4.853l-2.012-2.791a5.084 5.084 0 1 0-5.982.012l-2.014 2.793A8.526 8.526 0 0 1 11.979 3.42a8.526 8.526 0 0 1 8.526 8.526 8.511 8.511 0 0 1-3.512 6.898z"/></svg>`,
    styles: []
})
export class SimpleIconsCastroComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#00B265';
    @Input() className: string = 'simple-icons-castro'
    constructor() {}
    ngOnInit(): void {}
}
